import React from "react";
import { StaticQuery, graphql } from "gatsby";
import BookThumb from "../Book/BookThumb";
import Link from "../Link/Link";
import Newsletter from "../Newsletter/Newsletter";
import "./SubscribeCallout.scss";

export default function SubscribeCTA(props) {
  return (
    <div
      className={
        "subscribe-callout " +
        (props.type ? "subscribe-callout--" + props.type : "")
      }
    >
      <div className="subscribe-callout__intro">
        <h3 className="subscribe-callout__heading">
          What am I working on right now?
        </h3>
        <p>
          <strong>Subscribe to my newsletter</strong> and be the first to learn about my new projects and get exclusive content.
        </p>
        <Newsletter type={
          (props.type === 'stripped' ? "" : "right")
        } className="u-mar-top-lg" />
      </div>
      <ul className="subscribe-callout__books">
        <StaticQuery
          query={graphql`
            query preview {
              posts: allMarkdownRemark(
                sort: { order: DESC, fields: [frontmatter___date] }
                limit: 2
              ) {
                edges {
                  node {
                    id
                    frontmatter {
                      date(formatString: "MMMM DD, YYYY")
                      slug
                      title
                      bookCover {
                        childImageSharp {
                          gatsbyImageData(
                            width: 200
                            placeholder: BLURRED
                            formats: [AUTO, WEBP, AVIF]
                            quality: 100
                          )
                        }
                      }
                    }
                  }
                }
              }
            }
          `}
          render={(data) => {
            const Books = data.posts.edges.filter(
              (edge) => !!edge.node.frontmatter.date
            );

            return Books.map((edge) => (
              <li key={edge.node.id} className="subscribe-callout__book">
                <BookThumb
                  type="stripped"
                  wip={edge.node.frontmatter.wip}
                  link={edge.node.frontmatter.slug}
                  image={edge.node.frontmatter.bookCover}
                  title={edge.node.frontmatter.title}
                  series={edge.node.frontmatter.series}
                />
              </li>
            ));
          }}
        />
      </ul>
    </div>
  );
}
